module.exports = __webpack_public_path__ + "media/images/landing/bg/case-johany/instagram-1-7c6b1073f24109061b374b77246e8d67.jpg";